module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-ab4463f8.png";